import CardPublicidad from "./components/CardPublicidad";
import CardCursosHabilitados from "./components/CardCursosHabilitados";

const Cursos = () => {
    return (
        <>
            <CardPublicidad />
            <CardCursosHabilitados />
        </>
    );
};

export default Cursos;
